import { Chip } from "@material-ui/core";
import { memo } from "react";
import { useResultadoExercicioService } from "../contexts/ResultadoExercicioContext";

const FinanceChip = ({ financeCategory }) => {
  const { cachedFinanceCategories, applyFinanceFilter, handleCheck } =
    useResultadoExercicioService();

  const businessCenters = cachedFinanceCategories.map(
    (category) => category.id
  );

  const isBusinessCenter = businessCenters.includes(financeCategory.id);

  const isParent = !!financeCategory.children.length;

  const children = financeCategory.children.map((category) => (
    <FinanceChip financeCategory={category} key={category.id} />
  ));
  return (
    <>
      <Chip
        key={financeCategory.id}
        label={financeCategory.desc}
        onDelete={() => {
          const checkedCategories = handleCheck(financeCategory, false);
          applyFinanceFilter(checkedCategories);
        }}
        variant={isParent | isBusinessCenter ? "outlined" : "default"}
        color={
          isBusinessCenter ? "default" : isParent ? "secondary" : "primary"
        }
      />
      {children}
    </>
  );
};

export default memo(FinanceChip);
